import React, { useMemo } from "react";
import Editor from "../Editor";
import {
  conversationToEditorValue,
  updateTranscriptionItemsFromDoc,
  generateSpeakers,
} from "utils/transcription";

const ConversationEditor = ({
  transcriptionItems,
  speakerLabels,
  numSpeakers,
  time,
  onWordClick,
  saveTranscription,
  readOnly,
  className,
  docProps,
  doc,
  speakers,
  updateSpeakers,
}) => {
  // Minimize re-calculation of editor value across renders
  const editorValue = useMemo(
    () =>
      doc ||
      conversationToEditorValue(transcriptionItems, speakerLabels, numSpeakers),
    [transcriptionItems, speakerLabels, numSpeakers, doc]
  );

  const speakerList = useMemo(
    () => speakers || generateSpeakers(numSpeakers),
    [numSpeakers, speakers]
  );

  const updateTranscription = (doc) => {
    const editorContent = doc.toJSON().content;

    const updatedTranscriptionItems = updateTranscriptionItemsFromDoc(
      editorContent,
      transcriptionItems
    );

    if (saveTranscription) {
      saveTranscription(editorContent, updatedTranscriptionItems);
    }
  };

  return (
    <Editor
      initialValue={editorValue}
      time={time}
      onWordClick={onWordClick}
      readOnly={readOnly}
      onUpdate={updateTranscription}
      className={className}
      docProps={docProps}
      transcriptionItems={transcriptionItems}
      config="doc"
      speakers={speakerList}
      updateSpeakers={updateSpeakers}
    />
  );
};

export default ConversationEditor;
